import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import RegistrationPage from 'src/pages/registration/page';
import RetailerAccountRegistrationPage from 'src/pages/retailerAccountRegistration/page';
import { fetchSauronContext } from 'src/shared/state/redux';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/shared/state/store';

/**
 * Route component for the dedicated Sponsored Ads registration path
 * (/ads-account/registration/sa). The flow is encoded in the path (not the
 * adProductGroup query parameter) so the Mons gateway can attach the Policy15
 * challenge policy to SA registrations only. PLD retailer invitees land here
 * too: an 'invitationToken' query parameter selects the retailer registration
 * view, matching the legacy route behavior.
 */
const SaRegistrationRouter = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get('invitationToken');

  useEffect(() => {
    dispatch(fetchSauronContext());
  }, [dispatch]);

  return invitationToken ? (
    <RetailerAccountRegistrationPage invitationToken={invitationToken} />
  ) : (
    <RegistrationPage />
  );
};

export default SaRegistrationRouter;
